import Index from "@/Pages/GestaoDeAtendimentosCAEE/index.vue";
import NewCreateGestaoDeCAEE from "@/Pages/GestaoDeAtendimentosCAEE/NewCreateGestaoDeCAEE.vue";
import relatorioCAEE from "@/Pages/GestaoDeAtendimentosCAEE/relatorioCAEE.vue";
import { can } from "@/plugins/can";

export default [
  {
    path: "/gestoes-de-atendimentos-caee",
    name: "gestoesDeAulasCAEE",
    component: Index,
    beforeEnter(to, from, next) {
      if (!can(["gestoesDeAulasCAEE.listar", "gestoesDeAulasCAEE.*"])) {
        return next({ name: "NaoAutorizado" });
      }
      return next();
    },
  },
  {
    path: "/gestoes-de-atendimentos-caee-create",
    name: "gestoesDeAulasCAEE.newEdit",
    component: NewCreateGestaoDeCAEE,
    props: { editing: false },
    beforeEnter(to, from, next) {
      if (!can(["usersCaee.listar", "usersCaee.*"])) {
        return next({ name: "NaoAutorizado" });
      }
      return next();
    },
  },
  {
    path: "/gestoes-de-atendimentos-caEE/edit/:gestaoDeAulasId",
    name: "gestoesDeAulasCAEE.edit",
    component: NewCreateGestaoDeCAEE,
    props: { editing: true },
    beforeEnter(to, from, next) {
      if (!can(["usersCaee.listar", "usersCaee.*"])) {
        return next({ name: "NaoAutorizado" });
      }
      return next();
    },
  },
  {
    path: "/gestoes-de-atendimentos-caee-relatorio/:gestaoId",
    name: "gestoesCAEERelatorio.newEdit",
    component: relatorioCAEE,
  },
];
